import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { Image } from 'Components/Image';

import arrowLeftIcon from 'assets/images/homeRevamp/ArrowLeft.svg';
import arrowRightIcon from 'assets/images/homeRevamp/ArrowRight.svg';

const buttonArrowStyle = `
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  cursor: pointer;
  z-index: 1;
  border: none;
  background-color: ${theme.colors.neutral[300]};
  `;

/**
 * Positioning : to use the arrows you should provide a left, right and top value (leftAndRight, top)
 * these value are unique to the Slider its implemented in
 * Require to make it work : the container the slider should be position relative
 */

const ArrowButton = styled.button<{
  leftAndRight: ArrowProps['leftAndRight'];
  top: ArrowProps['top'];
  arrowDirection: ArrowProps['direction'];
  positioning: ArrowProps['positioning'];
}>`
  position: ${({ positioning }) => positioning};
  left: ${({ leftAndRight, arrowDirection }) =>
    arrowDirection === 'prev' ? `${leftAndRight}px` : 'auto'};
  right: ${({ leftAndRight, arrowDirection }) =>
    arrowDirection === 'prev' ? 'auto' : `${leftAndRight}px`};

  top: ${({ top }) => top}%;

  ${buttonArrowStyle}
`;

type ArrowProps = {
  direction: 'prev' | 'next';
  size?: number;
  top?: number;
  positioning?: string;
  dataFrom?: string;
  leftAndRight?: number;
  onClick: () => void;
};

export const SliderArrow = ({
  direction,
  dataFrom,
  size = 25,
  top = 45,
  leftAndRight,
  onClick,
  positioning = 'absolute',
}: ArrowProps) => {
  return (
    <ArrowButton
      arrowDirection={direction}
      data-click="change-slide-arrow"
      data-from={dataFrom}
      leftAndRight={leftAndRight}
      onClick={onClick}
      positioning={positioning}
      top={top}
    >
      <Image
        alt="go-next"
        height={size}
        src={direction === 'prev' ? arrowLeftIcon : arrowRightIcon}
        width={size}
      />
    </ArrowButton>
  );
};
